import twitterHtw from 'assets/images/hack-the-wind/wind-plant.png';
import fbWDM from 'assets/images/why-design-matters/fbOG.png';
import fbCareer from 'assets/images/career/career.png';
import fbRecommend from 'assets/images/career/recommend-cover.jpg';
import config from '../../../meta/config';

export const pages = {
  blog: {
    footer: true,
    navColors: ['white', 'mine-shaft'],
  },
  'hack-the-wind': {
    footer: true,
    navColors: ['white', 'violet', 'black'],
    siteTitle: 'Boldare Machine Learning Team in the final 3 of Hack the Wind',
    siteContent:
      'With the goal of resolving serious problems in the wind energy industry, Boldare’s team of five developers and a product designer took part in a prestigious hackathon. For 48 hours, they worked relentlessly to provide a machine learning-based product to predict wind turbine failures.',
    siteCover: twitterHtw,
  },
  article: {
    footer: true,
    navColors: ['black'],
  },
  work: {
    footer: true,
    navColors: ['mine-shaft', 'white', 'violet'],
    siteContent:
      "For the past 14 years we've helped over 90 clients to build more than 250 digital products. Explore our work.",
    items: {
      'why-design-matters': {
        footer: true,
        siteCover: fbWDM,
        siteContent:
          'A well-designed digital product does more than just function, it does so reliably and with a UX that gives the user exactly what they need and want.',
        navColors: ['white', 'mine-shaft'],
      },
    },
  },
  'privacy-policy': {
    footer: true,
    siteContent: 'Information we collect and how we use it.',
  },
  'development-teams': {
    footer: true,
    navColors: ['black', 'red'],
  },
  'machine-learning': {
    footer: true,
    navColors: ['black', 'pigeon-post'],
  },
  career: {
    footer: true,
    navColors: ['black', 'pigeon-post'],
    siteTitle: 'Careers at Boldare | Find your desired role',
    siteContent:
      'Here, you’re not “just” a developer or a designer. Grow your career with Boldare!',
    siteCover: fbCareer,
    items: {
      'recommend': {
        footer: true,
        siteContent:
          'Recommend a friend and get 4000 pln!',
        navColors: ['black', 'pigeon-post'],
        siteCover: fbRecommend,
      },
    },
  },
  'digital-transformation': {
    footer: true,
    navColors: ['black', 'red'],
  },
  'full-cycle-product-development': {
    footer: true,
    navColors: ['black', 'gray-light', 'violet'],
  },
  'product-design-and-development': {
    footer: true,
    navColors: ['black', 'gray-light', 'violet'],
  },
  contact: {
    footer: true,
    navColors: ['black', 'white', 'violet'],
    siteTitle: 'Contact us',
    siteContent:
      "Contact our digital product development team to see how we can support your product or a successful digital transformation. Drop us a line, and let's connect.",
  },
  'your-development-partner': {
    footer: true,
    navColors: ['black', 'white'],
  },
  newsletter: {
    footer: true,
    navColors: ['black', 'pigeon-post'],
  },
  resources: {
    footer: true,
    items: {
      'development-partner-guide': {
        navColors: ['black'],
        siteTitle: 'Development Partner Guide',
        siteContent:
          'Download our ebook for answers to the most common challenges facing C-level Executives when choosing a digital product development partner.',
      },
      'development-partner-checklist': {
        navColors: ['black'],
        siteTitle: '33 things to ask your digital product development partner',
        siteContent:
          'An ultimate checklist to guide you through the web development partner interviews covering all key areas of collaboration. Find answers to help you make the right decision.',
      }
    },
  },
  '404': {
    footer: true,
    navColors: ['black', 'mine-shaft'],
  },
  default: {
    footer: true,
    navColors: ['white', 'mine-shaft', 'violet'],
    siteTitle: config.siteTitle,
    siteContent: config.siteDescription,
    siteCover: config.siteCover,
  },
};
